import React from 'react';
import BaseRadio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

export interface RadioProps {
  options: { value: string; label: string }[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  value: string;
  label: string;
  error?: boolean;
  helperText?: string;
}

const Radio: React.FC<RadioProps> = ({
  label,
  options,
  value,
  onChange,
  error,
  helperText,
}) => {
  return (
    <FormControl error={error} color="primary" component="fieldset">
      <FormLabel style={{ margin: '10px 0' }} component="legend">
        {label}
      </FormLabel>
      <RadioGroup value={value} onChange={onChange} color="primary">
        {options.map((option) => (
          <FormControlLabel
            value={option.value}
            color="primary"
            control={<BaseRadio color="primary" />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default Radio;
